import Hero from '../components/Hero'
import SEO from '../components/SEO'
// import Events from '../components/Events'
import { AboutSection } from '../components/HomepageSections/AboutSection';
import { PlacesSection } from '../components/HomepageSections/PlacesSection';
import { EventsSection } from '../components/HomepageSections/EventsSection';
import { ProjectsSection } from '../components/HomepageSections/ProjectsSection';
import { ContactSection } from '../components/HomepageSections/ContactSection';
import { FooterSection } from '../components/HomepageSections/FooterSection';
import { Link } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { useState, useEffect } from 'react';

function Home() {
  // Deadline: December 12, 2025 at 12:00 PM (Noon)
  const DEADLINE = new Date('2025-12-12T12:00:00');
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const checkExpiration = () => {
      const now = new Date();
      setIsExpired(now > DEADLINE);
    };

    checkExpiration();
    const timer = setInterval(checkExpiration, 60000); // Check every minute
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <SEO
        title="Tamar Valley Business Association | Supporting Local Businesses in Launceston"
        description="Supporting local businesses in Northern Tasmania. Discover events, places, and community projects in Launceston and the Tamar Valley region."
        keywords="Tamar Valley, business association, Launceston, Tasmania, local business, community, events, Northern Tasmania, TVBA, local shops, business network"
      />

      {/* Prominent Feedback Button - REMOVED after deadline */}

      <Hero />
      <AboutSection />
      <PlacesSection />
      <EventsSection />
      <ProjectsSection />
      <ContactSection />
    </>
  )
}

export default Home